import type { IconNode, LucideIcon } from 'lucide-react'
import { createLucideIcon } from 'lucide-react'

// Personnel elevator — figure plus travel arrows.
export const ELEVATOR_NODES: IconNode = [
  [
    'path',
    {
      key: 'elevator-0',
      d: 'M16 8.25L18 6.25L20 8.25M16 12.25L18 14.25L20 12.25',
    },
  ],
  [
    'path',
    {
      key: 'elevator-1',
      d: 'M13.6666 16.25V14.9167C13.6666 14.2094 13.3856 13.5311 12.8855 13.031C12.3854 12.531 11.7072 12.25 10.9999 12.25H6.99992C6.29267 12.25 5.6144 12.531 5.1143 13.031C4.6142 13.5311 4.33325 14.2094 4.33325 14.9167V16.25M11.6666 6.91667C11.6666 8.38943 10.4727 9.58333 8.99992 9.58333C7.52716 9.58333 6.33325 8.38943 6.33325 6.91667C6.33325 5.44391 7.52716 4.25 8.99992 4.25C10.4727 4.25 11.6666 5.44391 11.6666 6.91667Z',
    },
  ],
  [
    'path',
    {
      key: 'elevator-2',
      d: 'M2.5 19.75H21.5',
    },
  ],
]

export const ElevatorIcon: LucideIcon = createLucideIcon(
  'elevator',
  ELEVATOR_NODES,
)
